import type { Identifier } from '@atlaskit/media-client/identifier';

// Media Viewer UI state that has to survive the viewer remounting when the renderer or editor
// writes a new document. Comment data and annotation ids come from the comment stores, not here.
// Nothing renders from this state, so it is read on demand rather than subscribed to: writing it
// must not re-render the page that owns the Media Viewer.
export type MediaViewerSidebarState = {
	isSidebarOpen: boolean;
	// The media card that originally opened the viewer. It keeps owning the viewer across remounts,
	// even after the user navigates to a different item inside it.
	viewerOpenFromIdentifier: Identifier | null;
	selectedIdentifier: Identifier | null;
};

const initialState: MediaViewerSidebarState = {
	isSidebarOpen: false,
	viewerOpenFromIdentifier: null,
	selectedIdentifier: null,
};

let state: MediaViewerSidebarState = initialState;

export const getMediaViewerSidebarState = (): MediaViewerSidebarState => state;

export const setMediaViewerSidebarOpen = (isSidebarOpen: boolean): void => {
	state = { ...state, isSidebarOpen };
};

export const setMediaViewerOpenFromIdentifier = (
	viewerOpenFromIdentifier: Identifier | null,
): void => {
	state = { ...state, viewerOpenFromIdentifier };
};

export const setMediaViewerSelectedIdentifier = (selectedIdentifier: Identifier | null): void => {
	state = { ...state, selectedIdentifier };
};

// The state is global so it survives remounts, which means it must be cleared when the page
// unmounts; otherwise the next page starts with the previous page's viewer state.
export const resetMediaViewerSidebar = (): void => {
	state = initialState;
};
